import buffer, { Buffer } from 'buffer';
export { buffer as 'buffer', Buffer as 'Buffer' }
